
function dateTimeDiferenceBetween(datumCas, datumCas2) {
    // Získání aktuálního data a času
    let aktualniCas = new Date(datumCas2);
  
    // Převedení vstupního data a času na objekt typu Date
    let zadaneDatumCas = new Date(datumCas);
  
    // Výpočet rozdílu v milisekundách
    let rozdilVmilisekundach =  aktualniCas - zadaneDatumCas;
  
    // Převod milisekund na minuty
    let rozdilVminutach = Math.floor(rozdilVmilisekundach / (60 * 1000));
  
    return rozdilVminutach;
  }

export default dateTimeDiferenceBetween